export default __webpack_public_path__ + "static/media/3.42dab2ea.png";